import { render, staticRenderFns } from "./PostSlug.vue?vue&type=template&id=08940f4a&"
import script from "./PostSlug.vue?vue&type=script&lang=js&"
export * from "./PostSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports